import { DivisionDrawerKey, DrawerConfigValues } from '../model';

export const DivisionDrawerConfig: Record<
  DivisionDrawerKey,
  DrawerConfigValues
> = {
  details: {
    tabName: '',
    sections: [
      {
        sectionName: '',
        blocks: [
          {
            inputs: [
              {
                inputType: 'textInput',
                name: 'name',
                label: 'Division Name',
                required: true,
              },
            ],
          },
          {
            inputs: [
              {
                inputType: 'textInput',
                name: 'code',
                label: 'Code',
                required: true,
              },
              {
                inputType: 'dropdownInput',
                name: 'headDivision',
                label: 'Head Division',
                required: true,
              },
            ],
          },
        ],
      },
    ],
  },
};
